import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'

import { getScheduleName } from './helpers'

export const useActiveSchedule = ({ formPath }) => {
  const [{ value: { activeAvailabilityRuleId, usingCustomHours, ownerAvailabilityRules } = {} }] = useFormField({ name: formPath })
  const primaryRuleId = ownerAvailabilityRules?.primaryRuleId || ownerAvailabilityRules?.primary_rule_id
  const memberSchedules = ownerAvailabilityRules?.rules

  const activeSchedule = (!usingCustomHours && memberSchedules)
    ? memberSchedules.find(({ id }) => id === activeAvailabilityRuleId) ?? null
    : null

  let activeScheduleName = ''

  if (usingCustomHours) {
    activeScheduleName = I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.custom_label')
  } else if (activeSchedule) {
    activeScheduleName = getScheduleName(activeSchedule.id === primaryRuleId, activeSchedule.name)
  }

  return { activeSchedule, activeScheduleName }
}
